<template>
  <section class="selftests__modal">
    <div class="response_table" v-if="this.type === 'selftest_list'">
      <h4 class="title">
        <span>{{ 'Test #'+this.data.id }}</span>
        <span>{{ this.get_date(this.data.ts) }}</span>
      </h4>
      <p class="duration">{{ translate('speed.duration') }}: {{duration}}</p>
      <table>
        <thead>
          <tr>
            <th rowspan="1" class="traffic_block">
              {{ translate('parameters') }} / {{ translate('self_tests.ifaces') }}
            </th>
            <th v-for="(item,key) in th" :key="key" class="traffic_block">
              {{ item.name }}
            </th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(item2,key2) in tr" :key="key2">
            <td class="tdFont traffic_block">
              {{ translate("self_tests." + item2.name2) }}
            </td>
            <td v-for="(val,dkey) in ifaces" :key="dkey">
              {{ result_data[val][item2.name2][0] }}
            </td>
          </tr>
        </tbody>
      </table>
    </div>

    <div v-else class="setting-card">
      <div class="setting-card_header">
        <span class="setting-card_header_name">
          {{ 'Test #'+this.data.id+'  '+this.get_date(this.data.ts) }}
        </span>
      </div>

      <div class="setting-card_content">
        <div v-for="(item, key) in get_list()" :key="key" class="setting-card_content_channels content-item" >
          <div class="left">
            <span class="title">{{key}}</span>
          </div>
          <div class="right">
            <span class="title">{{item}}</span>
          </div>
        </div>

      </div>
    </div>

    <div class="text-center">
      <button
        class="btn btn-danger btn-fill btn-wd marginButton"
        @click.prevent="cancel"
      >
        {{ translate('close_modal') }}
      </button>
    </div>
  </section>
</template>

<script>


export default {
  name: "SelfttestItem",
  props: ['type', 'data'],
  data () {
    return {
      th: [],
      tr: [],
      ifaces: [],
      result_data: [],
      duration: 0
    }
  },
  mounted () {
    this.get_list()
  },
  methods: {
    cancel () {
      this.$emit('close')
    },
    get_list(){
      if (this.type === 'selftest_list') {
        this.$http.v1.getDeviceTestSelfTestsResult( {selftest_id: this.data.id}, (response) => {

          let th = []
          let tr = []
          this.result_data = response.data.result
          this.duration = response.data.duration

          let name_iface = Object.keys(response.data.result)
          for (let i in name_iface) {
            th.push({name: name_iface[i]})
          }
          
          this.ifaces = name_iface
          this.th = th

          let parameters = Object.keys(response.data.result[name_iface[0]])
          for (let i in parameters) {
            tr.push({name2: parameters[i]})
          }
          this.parameters = parameters
          this.tr = tr

        })
      }else{
        return JSON.parse(this.data.param);
      }
    },
  },
}
</script>

<style lang="scss" scoped>
  .selftests__modal{
    .response_table{
      padding: 10px;
      .title{
        text-align: center;
        margin-top: 10px;
        text-transform: uppercase;
        span{
          display: block;
        }
      }
      .duration{
        text-align: center;
      }
    }
    .setting-card {
      color: #252422;
      padding-bottom: 10px;
      position: relative;
      border: 1px solid #ccc;
      min-height: 85px;
      background-color: #f8f8f8;
      &_header {
        font: 300 14px/20px "Roboto", Arial, sans-serif;
        text-transform: uppercase;
        color: #000;
        background: #f4f3ef;
        padding: 1rem 2rem;
        border-radius: 10px 10px 0 0;
        display: flex;
        align-items: center;
        justify-content: center;
      }
      &_content {
        font: 300 12px/16px "Roboto", Arial, sans-serif;
        text-align: center;
        .content-item{
          display: flex;
          justify-content: center;
          align-items: flex-start;
          padding: 5px;
          &:nth-child(2n+1) {
            background-color: #e2ecdc;
          }
          .left{
            width: 40%;
          }
          .right{
            width: 60%;
          }
          div{
            display: flex;
            align-items: center;
            justify-content: flex-start;
            font-size: 12px;
            height: 100%;
            span{
              text-overflow: ellipsis;
            }
          }
        }
      }
      &_footer {
        text-align: center;
        padding: 15px 0 5px;
        border-top: 1px solid #ccc;
      }
    }
    .text-center{
      padding-bottom: 10px;
    }
  }

  @media (max-width: 475px) {
    .setting-card {
      &_content {
        .content-item{
          flex-wrap: wrap;
          .left{
            width: 100%;
          }
          .right{
            width: 100%;
          }
        }
      }
    }
  }
</style>
